// 과제를 출제할 수 있는 지인에듀 플랜. 서버의 assignment/views.py 와 같은 목록이다.
// basic, free, 미가입은 문제지 목록만 볼 수 있고 출제 단계에서 막힌다.
export const ASSIGNMENT_ALLOWED_PLAN_LIST = ["plus", "premium"];

export const ASSIGNMENT_PLAN_REQUIRED_MESSAGE =
  "Plus, Premium 사용자만 출제 가능합니다.\n플랜을 업그레이드해주세요.";

export const canCreateAssignment = (plan) =>
  ASSIGNMENT_ALLOWED_PLAN_LIST.includes(plan);

// 학원 관리 > 프로모션도 Plus, Premium 만 쓴다(2026-10-01). 서버 echo/academy_promo_views.py 의
// PROMOTION_ALLOWED_PLAN_LIST 와 같은 목록이다. 다른 플랜은 탭을 누르면 안내만 띄우고 열지 않는다.
export const PROMOTION_ALLOWED_PLAN_LIST = ["plus", "premium"];

export const PROMOTION_PLAN_REQUIRED_MESSAGE =
  "블로그/카페/인스타/당근용 홍보자료를 자동으로 드리는 기능입니다.\nPlus 이상 회원에게만 제공됩니다.";

export const canUsePromotion = (plan) => PROMOTION_ALLOWED_PLAN_LIST.includes(plan);

// 직독직해+ 옵션 (지인에듀 구독관리 추가 상품). 서버의 assignment/views.py,
// echo/bank_views.py 와 같은 목록이다. addons 키는 "speaking" 이고 예전 설계
// 이름 "problem_bank" 도 함께 인정한다.
export const DIRECT_PLUS_ADDON_KEY_LIST = ["speaking", "problem_bank"];

export const hasDirectPlusAddon = (user) => {
  // 서버가 전환 시각·예외 학원까지 계산한 최종 판정을 내려준다. 그것을 먼저 쓰고,
  // 아직 안 내려오는 판(구버전 응답)에서만 addons 를 직접 본다.
  if (typeof user?.direct_plus_active === "boolean") return user.direct_plus_active;
  return DIRECT_PLUS_ADDON_KEY_LIST.some((key) => (user?.addons || []).includes(key));
};

export const DIRECT_PLUS_REQUIRED_MESSAGE =
  "직독직해는 직독직해+ 옵션 가입 학원만 출제할 수 있어요.\n" +
  "구독관리에서 옵션을 추가하거나, 문제지 목록 맨 위의 체험 문제지에서 먼저 눌러보세요.";
